import React, { useState } from 'react';
import { Link } from "react-router-dom";

import { Sidebar, Menu, MenuItem, SubMenu, useProSidebar } from 'react-pro-sidebar';
import { WhiteLogoLarge, WhiteLogoSmall, ColorLogoLarge, ColorLogoSmall } from "./Logo";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faProjectDiagram, faDraftingCompass, faBook, faCalendarAlt, faCheckSquare, faBan, faChartLine, faMagnifyingGlassChart, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

function SideMenu({ menuCollapse, menuItems, sysAdmin } ) {

    const { collapseSidebar, collapsed } = useProSidebar();

    React.useEffect(() => {
        if (collapsed !== menuCollapse) {
            collapseSidebar(menuCollapse);
        }
    });

    const menuIcon = (iconNum) => {
        switch (iconNum) {
            case 0:
                return <FontAwesomeIcon icon={faProjectDiagram} />
                break;
            case 1:
                return <FontAwesomeIcon icon={faDraftingCompass} />
                break;
            case 2:
                return <FontAwesomeIcon icon={faCheckSquare} />
                break;
            case 3:
                return <FontAwesomeIcon icon={faBook} />
                break;
            case 4:
                return <FontAwesomeIcon icon={faCalendarAlt} />
                break;
            case 5:
                return <FontAwesomeIcon icon={faChartLine} />
                break;
            case 6:
                return <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                break;
            case 7:
                return <FontAwesomeIcon icon={faTriangleExclamation} />
                break;
            default:
                return <FontAwesomeIcon icon={faBan} />
        }
    }

    return (
        <div style={{ display: 'flex', height: '100%', minHeight: '400px' }}>
            <Sidebar
                width="14rem"
                backgroundColor="transparent"
                //rootStyles={{ background: 'linear-gradient(0deg, CornflowerBlue, royalblue)', }}
                rootStyles={{ background: 'linear-gradient(0deg, White, #f8f9fa)', }}
            >
                <div className="logotext">
                    <p>{menuCollapse ? <ColorLogoSmall /> : <ColorLogoLarge />}</p>
                </div>
                <Menu 
                    style={{marginTop:'3rem'} }
                    menuItemStyles={{
                        button: ({ level, active, disabled }) => {
                            // only apply styles on first level elements of the tree
                            if (level === 0)
                                return {
                                    color: disabled ? '#101010' : '#000000',
                                    backgroundColor: active ? 'rgba(0, 0, 0, 0.0)' : undefined,
                                    //fontWeight: 'bold',
                                    //fontSize: '14px',
                                    "&:hover": {
                                        backgroundColor: " rgba(27, 110, 194, 1) !important",
                                        color: '#FFFFFF',
                                    },
                                };
                            else 
                                return {
                                    color: disabled ? '#101010' : '#000000',
                                    backgroundColor: active ? 'rgba(0, 0, 0, 0)' : undefined,
                                    //fontWeight: 'bold',
                                    //fontSize: '14px',
                                    "&:hover": {
                                        backgroundColor: "rgba(27, 110, 194, 1) !important",
                                        color: '#FFFFFF',
                                    },
                                };
                        },
                        icon: ({ level, active, disabled }) => {
                            if (level === 0)
                                return {
                                    backgroundColor: 'rgba(27, 110, 194, 1)',
                                    color: '#FFFFFF',
                                    borderRadius: '3px',
                                };
                        },            
                        subMenuContent: {
                            backgroundColor: 'rgba(255, 255, 255, 1)',
                        },
                    }}

                >
                    {menuItems.map((item, index) => (
                        <MenuItem key={index} icon={menuIcon(item.icon)} component={<Link to={item.link} />}>{item.text}</MenuItem>
                    ))}
                    <hr></hr>
                    {sysAdmin ?    
                        <SubMenu
                            label="System Admin"
                            icon={menuIcon(1)}
                        >
                            <MenuItem component={<Link to="/AdmOrganisations" />}>Organisations</MenuItem>
                            <MenuItem component={<Link to="/AdmUsers" />}>Users</MenuItem>
                        </SubMenu>
                        : null}
                </Menu>
            </Sidebar>
        </div >
    );
}

export default SideMenu;

